import axios from 'axios';

const api = axios.create({
    withCredentials: true,
    baseURL: `https://calculacake.com/api/`
});

export default api;
